import axios from "axios";
export function benefitbannerAPI(config, callback, errorcallback){
  const URL = process.env.REACT_APP_BASE_URL+'getPage12Block1';
    axios.get(URL, config)
    .then(res => {
      //do something
    //  console.log("Benefit banner api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
       // console.log("benefits banner not api working");
         errorcallback(err);
      }
    })
}
export function benefitcontentAPI(config, callback, errorcallback){
  const URL = process.env.REACT_APP_BASE_URL+'getPage12Block2';
    axios.get(URL, config)
    .then(res => {
      //do something
     // console.log("benefit contents api working");
      if(callback != null){
         callback(res);
      }
    })
    .catch(err => {
      // catch error
      if(errorcallback != null){
       // console.log("benefits content not api working");
         errorcallback(err);
      }
    })
}